import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Case } from '../schemas/shared';
import useApi from './useApi';

export const useCaseByIdQuery = (caseId?: number): UseQueryResult<Case | null> => {
  const { Api } = useApi();

  return useQuery({
    queryKey: ['case', caseId],
    queryFn: async () => {
      const response = await Api.cases.getCases({ case: caseId });
      return response?.cases?.[0] ?? null;
    },
    enabled: !!caseId
  });
};

export default useCaseByIdQuery;
